module.exports = __webpack_public_path__ + "img/The-Good-Gateway-Green-08.abff9d02.jpg";